import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  theme: {},
};

const ThemeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    GetTheme(state, action) {
      state.theme = action.payload;
    },
  },
});
export default ThemeSlice.reducer;
export const { GetTheme } = ThemeSlice.actions;
